"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConvertkitProvider = exports.ConvertkitContext = void 0;
exports.useConvertkit = useConvertkit;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var lodash_1 = require("lodash");
var axios_1 = __importDefault(require("@skillrecordings/axios"));
var config_1 = require("@skillrecordings/config");
var js_cookie_1 = __importDefault(require("js-cookie"));
var defaultConvertKitContext = {
    loadingSubscriber: true,
};
/**
 * @deprecated use skill-lessons packages instead
 */
exports.ConvertkitContext = React.createContext(defaultConvertKitContext);
/**
 * @deprecated use skill-lessons packages instead
 * @param children
 * @param getSubscriberApiUrl
 * @constructor
 */
var ConvertkitProvider = function (_a) {
    var children = _a.children, _b = _a.getSubscriberApiUrl, getSubscriberApiUrl = _b === void 0 ? process.env.NEXT_PUBLIC_CONVERTKIT_GET_SUBSCRIBER_URL ||
        "/api/subscriber" : _b;
    var _c = React.useState(), subscriber = _c[0], setSubscriber = _c[1];
    var _d = React.useState(true), loadingSubscriber = _d[0], setLoadingSubscriber = _d[1];
    React.useEffect(function () {
        var _a;
        if (typeof window !== 'undefined') {
            var params = new URLSearchParams(window.location.search);
            var ckSubscriberId = params.get(config_1.CK_SUBSCRIBER_KEY);
            if (!(0, lodash_1.isEmpty)(ckSubscriberId)) {
                params.delete(config_1.CK_SUBSCRIBER_KEY);
                window.history.replaceState(null, document.title, "".concat(window.location.pathname, "?").concat(params.toString()));
            }
            try {
                var subscriber_1 = js_cookie_1.default.get('ck_subscriber');
                if (subscriber_1) {
                    setSubscriber(JSON.parse(subscriber_1));
                    setLoadingSubscriber(false);
                }
            }
            catch (e) {
                console.debug("couldn't load ck subscriber cookie");
            }
            //get the subscriber (which sets the cookie)
            axios_1.default
                .get(getSubscriberApiUrl, {
                params: (_a = {},
                    _a[config_1.CK_SUBSCRIBER_KEY] = ckSubscriberId,
                    _a),
            })
                .then(function (_a) {
                var data = _a.data;
                setSubscriber(data);
            })
                .finally(function () { return setLoadingSubscriber(false); });
        }
    }, []);
    return ((0, jsx_runtime_1.jsx)(exports.ConvertkitContext.Provider, { value: { subscriber: subscriber, loadingSubscriber: loadingSubscriber }, children: children }));
};
exports.ConvertkitProvider = ConvertkitProvider;
/**
 * @deprecated use skill-lessons packages instead
 */
function useConvertkit() {
    return React.useContext(exports.ConvertkitContext);
}
